import { render } from "./EditChoices.vue?vue&type=template&id=558bec1c&scoped=true"
import script from "./EditChoices.vue?vue&type=script&lang=ts"
export * from "./EditChoices.vue?vue&type=script&lang=ts"

import "./EditChoices.vue?vue&type=style&index=0&id=558bec1c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-558bec1c"

export default script